import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import About from '../views/About.vue';
import World from '../views/World.vue';
import India from '../views/India.vue';
import Dummy from '../views/Dummy.vue';
import MainContent from '../components/MainContent.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: MainContent,
    children:
    [
      // { path: 'home', name: 'Home', component: Home, meta: { description: ' for Sanity Testing' }},
      { path: 'world', name: 'World', component: World },
      { path: 'world', alias: '' },
      { path: 'india', name: 'india', component: India },
      { path: 'dummy', name: 'Dummy', component: Dummy },
      { path: 'about', name: 'About', component: About },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
